// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.arcade-cabinet-image-preview {
  display: block;
  max-width: 100%;
  max-height: 16em;
  margin-left: auto;
  margin-right: auto;
}
.nkl-popover-inner-content {
  padding: 0px;
}
.nkl-btn-icon-only {
  border: 0px;
}
.nkl-btn {
  border-radius: 3px;
}
.arcade-game-name {
  padding-left: 10px;
  padding-right: 10px;
  border-bottom: 1px solid lightgrey;
}
/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */
/* stylelint-disable no-duplicate-selectors */
/* stylelint-disable */
/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
